const constants = {
  authentication: {
    publicV1: "authentication/api/public/v1/",
    publicV2: "authentication/api/public/v2/",
    userV1: "authentication/api/v1/",
  },
  baloot: {
    userController: "baloot/api/user/",
    userControllerV2: "baloot/api/v2/user/",
    userControllerV3: "baloot/api/v3/user/",
  },
  messaging: {
    userMessageController: "messaging/api/messages/",
  },
};

export default constants;
